var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c(("Icon" + _vm.name),{tag:"component",attrs:{"options":_vm.$attrs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }